import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { EventQuery } from 'generated/graphql'
import { RequestStatus } from 'types'
import { QueryResponse } from 'utils/graphql'
import { getNodes } from 'graphql/utils'
import { RootState } from 'store'
import { getTimeFormat } from 'utils/datetime'
import { getEvent } from '../generalsettings/graphql/query'

export const getEventData = createAsyncThunk(
    'GET_EVENT',
    (eventSlug: string) => getEvent({ eventId: eventSlug }),
)

const eventSlice = createSlice({
    name: 'eventSlice',
    initialState: {
        response: undefined as QueryResponse<EventQuery>,
        requestStatus: 'idle' as RequestStatus,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getEventData.fulfilled, (state, { payload }) => {
            state.response = payload
            state.requestStatus = 'succeeded'
        })
        builder.addCase(getEventData.pending, (state) => {
            state.requestStatus = 'loading'
        })
        builder.addCase(getEventData.rejected, (state) => {
            state.requestStatus = 'failed'
        })
    },
})

export const eventSelector = (state: RootState) => state.event?.response?.data?.event
export const requestStatusSelector = (state: RootState) => state.event?.requestStatus
export const spacesStatusSelector = (state: RootState) => {
    const event = state.event?.response?.data?.event
    // This assumes all booths are loaded, and it will break with pagination
    const boothSpaces = state.event
        ? getNodes(event?.spaces).filter((e) => e.type === 'booth').length
        : 0
    const numberOfSpaces = event
        ? event.spaces.totalCount - boothSpaces
        : 0

    return {
        normalSpaces: getNodes(event?.spaces).filter((e) => e.type !== 'booth') || [],
        numberOfSpaces,
        maxSpaces: event?.maxSpaces || 0,
        boothSpaces,
        maxBooths: event?.maxBooths || 0,
    }
}
export const allSpacesSelector = (state: RootState) => {
    const event = state.event?.response?.data?.event
    return getNodes(event?.spaces)
}
export const eventOrganizationIdSelector = (state: RootState) => (
    state.event?.response?.data?.event?.organization?.id
)
export const timeFormatSelector = (state: RootState) => (
    getTimeFormat(state.event?.response?.data?.event?.timeFormat)
)
export const maxParticipantsSelector = (state: RootState) => (
    state.event?.response?.data?.event?.maxParticipants
)
export const sponsorSelector = (state: RootState) => {
    const event = state.event?.response?.data?.event
    return getNodes(event?.spaces).filter((e) => e.type === 'booth')
}
export const mapsSelector = (state: RootState) => {
    const event = state.event?.response?.data?.event
    return event?.maps || []
}

export default eventSlice.reducer
